module.exports = "<p>\r\n  page-not-found-component works!\r\n</p>\r\n"